import { render, staticRenderFns } from "./polygon-editor.vue?vue&type=template&id=5639807a"
import script from "./polygon-editor.vue?vue&type=script&lang=js"
export * from "./polygon-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports